export class StaticsModel {

    snowLoadF: number;
    snowLoadG: number;
    snowLoadH: number;
    /**
     * in Pa (Pascal)
     */
    windLoadF: number;
    windLoadG: number;
    windLoadH: number;
    /**
     * in Pa (Pascal)
     */
    totalPressureF: number;
    totalPressureG: number;
    totalPressureH: number;
    /**
     * in Pa (Pascal)
     */
    suctionF: number;
    suctionG: number;
    suctionH: number;
    /**
     * in cm
     */
    maxSpanWidthPortraitF: number;
    maxSpanWidthPortraitG: number;
    maxSpanWidthPortraitH: number;
    /**
     * in cm
     */
    maxSpanWidthLandscapeF: number;
    maxSpanWidthLandscapeG: number;
    maxSpanWidthLandscapeH: number;
    /**
     * in cm
     */
    minCantileverPortraitF: number;
    minCantileverPortraitG: number;
    minCantileverPortraitH: number;
    /**
     * in cm
     */
    minCantileverLandscapeF: number;
    minCantileverLandscapeG: number;
    minCantileverLandscapeH: number;
    /**
     * in cm
     */
    maxCantileverPortraitF: number;
    maxCantileverPortraitG: number;
    maxCantileverPortraitH: number;
    /**
     * in cm
     */
    maxCantileverLandscapeF: number;
    maxCantileverLandscapeG: number;
    maxCantileverLandscapeH: number;
}
